<template>
  <q-tab-panel :class="{ 'q-pa-none': noPadding, 'no-mobile-padding': noMobilePadding }" :name="name">
    <slot />
  </q-tab-panel>
</template>

<script>
export default {
  name: 'TabPanel',
  props: {
    name: String,
    noMobilePadding: Boolean,
    noPadding: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.no-mobile-padding {
  @media (max-width: $breakpoint-sm) {
    padding: 0;
  }
}
</style>
